import { useTranslation } from "react-i18next";
import { useOutletContext } from 'react-router-dom';
import DividerWithText from "../../../../components/DividerWithText";
import CustomHorizontalInfiniteScroll from '../../../../components/HorizontalInfiniteScroll/CustomHorizontalInfiniteScroll';
import NotInformation from "../../../../components/NotInformation";
import DishCard from "../ContentSteps/DinningOrder/DishCard";
import { TITLES_MEALS } from '../Model/MealModel';

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

/**
 * Component for rendering categorized dish cards grouped by course type,
 * allowing horizontal scrolling and selection behavior.
 *
 * @component
 * @param {Object} props - Component properties.
 * @param {string} [props.className=""] - Optional CSS class for each course container.
 * @param {Function} props.handleSelection - Function to handle selection of a dish.
 * @param {Array} props.dishes - Dishes Array to select.
 * @param {boolean} props.codeMessage - Code Message
 *
 * @returns {JSX.Element} Rendered meal items grouped by course type.
 *
 * @example
 * <MealItemCards handleSelection={handleDishSelect} />
 */


const MealItemCards = ({ className = "", handleSelection, dishes, codeMessage }) => {
    const { t } = useTranslation();
    const { meal } = useOutletContext();



    if (!dishes.length) return (
        <div className="w-100 h-50 background-shades-100">
            <NotInformation text={t('no_meals_are_linked_to_this_mealtime') || codeMessage} />
        </div>
    )

    return (
        <>
            {dishes.map(({ foodieCourseTypeId, meals }) => {
                // Determine which dishes have already been selected
                const selectedDishIds = meal.menuMealTimeIds || [];
                const selectedInThisCourse = meals.some(dish => selectedDishIds.includes(dish.id));

                return (
                    <div key={foodieCourseTypeId} className={className}>
                        <DividerWithText title={t(TITLES_MEALS[foodieCourseTypeId] || '')} />
                        <div className={"mt-4"}>
                            <CustomHorizontalInfiniteScroll
                                items={meals}
                                scrollStep={450}
                                renderItem={(dish) => {

                                    //Renders each dish card with grayscale effect and disabled buttons
                                    //if another dish of the same course type has already been selected.
                                    const isSelected = selectedDishIds.includes(dish.id);
                                    const shouldBeGrayscale = selectedInThisCourse && !isSelected;

                                    return (
                                        <DishCard
                                            key={dish.id}
                                            dish={dish}
                                            info={dish.foodieItem}
                                            onClick={handleSelection}
                                            className={shouldBeGrayscale ? 'grayscale' : ''}
                                            disableButtons={shouldBeGrayscale}
                                            isSelected={isSelected}
                                        />
                                    );
                                }}
                            />
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default MealItemCards;
